import http from '@/utils/request'

const obj = {
  oauth (param) { return http.get('/index.php/LigaoApi/missOauth.html', param) },
  saveMissImg (param) {
    return http.post('/index.php/LigaoApi/saveMissImg.html', param, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  },
  getDrawInfo (param) { return http.get('/index.php/LigaoApi/getDrawInfo.html', param) },
  saveMissUser (param) { return http.get('/index.php/LigaoApi/saveMissUserInfo.html', param) },
  isDraw (param) { return http.get('/index.php/LigaoApi/isDraw.html', param) },
  getShare (param) { return http.get('/index.php/LigaoApi/getMissShare.html', param) }
}

const api = Object.assign({}, http, obj)

export default api
